export const CONFIGURATIONS_INIT = 'CONFIGURATIONS_INIT'
export const CONFIGURATIONS_ITEM_TABLE = 'CONFIGURATIONS_ITEM_TABLE'
export const CONFIGURATIONS_ITEM_EDIT = 'CONFIGURATIONS_ITEM_EDIT'
export const CONFIGURATIONS_ITEM_VIEW = 'CONFIGURATIONS_ITEM_VIEW'
export const CONFIGURATIONS_ITEM_STRUCTURE = 'CONFIGURATIONS_ITEM_STRUCTURE'
export const CONFIGURATIONS_PERMISSIONS = 'CONFIGURATIONS_PERMISSIONS'
export const CONFIGURATIONS_BATCH_UPDATE = 'CONFIGURATIONS_BATCH_UPDATE'
export const CONFIGURATIONS_TABLE_FILTER = 'CONFIGURATIONS_TABLE_FILTER'
export const UPDATE_ITEM_DATA = 'UPDATE_ITEM_DATA'
export const CONFIGURATIONS_RECALCULATE_ATTRIBUTES_LIST = 'CONFIGURATIONS_RECALCULATE_ATTRIBUTES_LIST'
